/** Limites do diálogo de inserir tabela do prontuário. */
export const TABLE_MIN = 1;
export const TABLE_MAX_ROWS = 20;
export const TABLE_MAX_COLS = 10;

export function clampRows(value: number): number {
  return clamp(value, TABLE_MIN, TABLE_MAX_ROWS);
}

export function clampCols(value: number): number {
  return clamp(value, TABLE_MIN, TABLE_MAX_COLS);
}

function clamp(value: number, min: number, max: number): number {
  if (!Number.isFinite(value)) return min;
  return Math.min(max, Math.max(min, Math.trunc(value)));
}

/**
 * HTML de uma tabela vazia com o número de linhas e colunas escolhido.
 *
 * Antes o botão inseria uma tabela fixa já preenchida ("Sintoma/Fenômeno",
 * "Ansiedade", "7"…), conteúdo que não tinha relação com a sessão e que o
 * usuário precisava apagar à mão.
 *
 * @param rows linhas de conteúdo (fora o cabeçalho)
 * @param cols colunas
 * @param withHeader gera a primeira linha como cabeçalho
 */
export function buildTableHtml(rows: number, cols: number, withHeader = true): string {
  const r = clampRows(rows);
  const c = clampCols(cols);

  const border = 'border: 1px solid #cbd5e1;';
  const cell = `${border} padding: 10px; min-width: 60px;`;
  const headCell = `${cell} font-weight: bold; text-align: left; background-color: #f1f5f9;`;

  const head = withHeader
    ? `<thead><tr>${Array.from({ length: c }, () => `<th style="${headCell}"><br/></th>`).join('')}</tr></thead>`
    : '';

  const body = Array.from(
    { length: r },
    () => `<tr>${Array.from({ length: c }, () => `<td style="${cell}"><br/></td>`).join('')}</tr>`,
  ).join('');

  return (
    `<table style="width: 100%; border-collapse: collapse; margin: 15px 0; ${border}">` +
    `${head}<tbody>${body}</tbody></table><p><br/></p>`
  );
}
